export default "__VITE_ASSET__LFkpd1ns__"